import { Modal } from '@heroui/react'
import { useTranslation } from 'react-i18next'

import { WarehouseInstallForm } from './WarehouseInstallForm'

interface WarehouseInstallDialogProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  articleId?: string;
  initialArticleName?: string;
}

export function WarehouseInstallDialog({ isOpen, onOpenChange, articleId, initialArticleName }: WarehouseInstallDialogProps) {
  const { t } = useTranslation()

  const closeModal = () => onOpenChange(false)

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
      <Modal.Backdrop variant="blur" className="bg-zinc-950/40" isDismissable>
        <Modal.Container placement="center">
          <Modal.Dialog>
            <Modal.CloseTrigger />
            <Modal.Header>
              <Modal.Heading className="font-bold">
                {articleId ? t('warehouse.edit_install') : t('warehouse.new_install')}
              </Modal.Heading>
            </Modal.Header>
            <Modal.Body className={'mt-4'}>
              <WarehouseInstallForm
                key={articleId || initialArticleName || 'new'}
                articleId={articleId}
                initialArticleName={initialArticleName}
                onSuccess={closeModal}
                onCancel={closeModal}
              />
            </Modal.Body>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </Modal>
  )
}
